export default __webpack_public_path__ + "static/media/apple-pay-grey.20a3f0f5.png";